import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

export const generateQuotes = createAsyncThunk(
    'quoteGenerator/generateQuotes',
    async ({ text, theme }, { rejectWithValue }) => {
        try {
            const response = await apiCall('/generate-quotes', 'POST', { text, theme });
            if (response.error) {
                return rejectWithValue(response.message || response.error);
            }
            return response;
        } catch (error) {
            return rejectWithValue('Error generating quotes');
        }
    }
);

const quoteSlice = createSlice({
    name: 'quoteGenerator',
    initialState: {
        quotes: [],
        loading: false,
        error: null,
    },
    reducers: {
        clearQuotes: (state) => {
            state.quotes = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateQuotes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(generateQuotes.fulfilled, (state, action) => {
                state.loading = false;
                state.quotes = action.payload.quotes;
            })
            .addCase(generateQuotes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'An unexpected error occurred';
            });
    },
});

export const { clearQuotes } = quoteSlice.actions;
export default quoteSlice.reducer;
